import Image from '@components/Image'
import classnames from '@helpers/misc/classnames'

export default function WebsiteCoinsImage({customStyle = null}) {
  const style = classnames('flex items-center mr-1 w-5 relative justify-center', customStyle)

  return (
    <div className={style}>
      <Image
        src="https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FM6Wexw4yRsJDacfMJ-website-coins.svg"
        alt="WebsiteCoinsLogo"
        title="websiteCoinsLogo"
        height={20}
        width={20}
        objectFit="contain"
        layout="fill"
      />
    </div>
  )
}
